export default __webpack_public_path__ + "static/media/vdo.7a5c5361.png";